<mat-drawer-container>
  <mat-drawer opened [mode]="sidenavMode" #sidenav [disableClose]="sidenavMode === 'side'">
    <div fxLayout="column" class="navList">
      <app-events-tree
        [setEventBlocks]="eventBlocks"
        [selectedEvent]="selectedEvent"
        (updateFilter)="updateFilter($event)">
      </app-events-tree>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <div fxLayout="column" class="content customBackgroundColor2 navList autoScrollY">
      <div fxFlex fxLayoutAlign="space-between center">
        <div class="d-flex-center">
          <mat-form-field class="filter">
            <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
            <input matInput inputrestriction="basic1" autocomplete="off" type="text" (keyup)="applyFilter($event.target['value'])" name="SearchDualList" class="form-control" [(ngModel)]="globalFilter" autocomplete="off"/>
            <a matSuffix aria-label="Clear" (click)="clearSelection()">
              <mat-icon>close</mat-icon>
            </a>
          </mat-form-field>

          <mat-form-field style="padding-left: 30px">
            <mat-label>filter by event</mat-label>
            <mat-select [(value)]="columnFilter['eventName']" (selectionChange)="filterByEventName($event.value)">
              <mat-option value="">{{'general.selectAll' | transloco}}</mat-option>
              @for (str of eventStrings; track str) {
                <mat-option [value]="str">{{str}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="d-flex-center">
          <button mat-icon-button (click)="jumpToSceneItem()" matTooltip="{{'general.jumpToSceneItem' | transloco}}"
            [disabled]="selection.selected.length == 0 || selection.selected[0]?.eventSceneId === 'none'">
            <mat-icon>link</mat-icon>
          </button>

          <button mat-icon-button [disabled]="selection.selected.length !== 1"
            (click)="deleteEvent()" matTooltip="{{'general.deleteEvents' | transloco}}">
            <mat-icon>delete_outline</mat-icon>
          </button>

          <app-video-link videoLink="/help/Button"></app-video-link>

          <button (click)="toggleVideoPane(); sidenav.toggle()" mat-icon-button>
            @if (toggleIcon) {
              <mat-icon>keyboard_double_arrow_left</mat-icon>
            }
            @if (!toggleIcon) {
              <mat-icon>keyboard_double_arrow_right</mat-icon>
            }
          </button>
        </div>
      </div>
      <div class="events-table-wrapper">
        <table mat-table matSort [dataSource]="dataSource" multiple="false">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              @if (allowMultiSelect) {
                <mat-checkbox
                  [checked]="selection.hasValue()"
                  [indeterminate]="selection.hasValue()">
                </mat-checkbox>
              }
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="icon">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'general.component' | transloco}}</th>
            <td mat-cell *matCellDef="let element">
              <fa-icon size="xl" [icon]="element.eventBlockPlayer | PipeIcon"></fa-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="eventName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'general.eventName' | transloco}}</th>
            <td mat-cell style="padding-left: 3px" *matCellDef="let element">{{element.eventName}}</td>
          </ng-container>
          <ng-container matColumnDef="eventType">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'general.type' | transloco}}</th>
            <td mat-cell *matCellDef="let element">{{element.eventType}}</td>
          </ng-container>
          <ng-container matColumnDef="sceneName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'general.source' | transloco}}</th>
            <td mat-cell *matCellDef="let element">{{element.sceneName}}</td>
          </ng-container>
          <ng-container matColumnDef="eventSceneId">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'general.identifier' | transloco}}</th>
            <td mat-cell *matCellDef="let element">{{element.eventSceneId}}</td>
          </ng-container>
          <ng-container matColumnDef="blockName">
            <th mat-header-cell *matHeaderCellDef> {{'general.from' | transloco}}</th>
            <td mat-cell *matCellDef="let element">{{element.blockName}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <ng-container>
        <mat-paginator customPageSize [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          [showFirstLastButtons]="true">
        </mat-paginator>
      </ng-container>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
